import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Code } from 'lucide-react';
import { servicePricing } from '../../mockData';

const WebDevelopment = () => {
  const features = [
    {
      title: "Responsive Design",
      description: "Mobile-first approach ensuring your site looks perfect on all devices"
    },
    {
      title: "Modern Frameworks",
      description: "Built with React, Vue, or Next.js for optimal performance"
    },
    {
      title: "SEO Optimized",
      description: "Clean code and structure to rank higher in search engines"
    },
    {
      title: "Fast Loading",
      description: "Optimized assets and code for lightning-fast page loads"
    },
    {
      title: "CMS Integration",
      description: "Easy content management with platforms like WordPress or Contentful"
    },
    {
      title: "Security First",
      description: "HTTPS, secure authentication, and regular security updates"
    }
  ];

  const benefits = [
    {
      title: "Professional Online Presence",
      description: "Make a lasting impression with a website that reflects your brand's quality and professionalism"
    },
    {
      title: "Increase Conversions",
      description: "Strategic design and UX that guides visitors to take action and become customers"
    },
    {
      title: "24/7 Availability",
      description: "Your website works for you around the clock, reaching customers while you sleep"
    },
    {
      title: "Scalable Solution",
      description: "Built to grow with your business - easily add features and pages as needed"
    }
  ];

  const process = [
    {
      title: "Discovery & Planning",
      description: "We learn about your business, goals, and target audience to create a strategic plan"
    },
    {
      title: "Design & Prototyping",
      description: "Create mockups and interactive prototypes for your approval before development"
    },
    {
      title: "Development & Testing",
      description: "Build your website with clean code and test across all devices and browsers"
    },
    {
      title: "Launch & Support",
      description: "Deploy to production and provide ongoing support and maintenance"
    }
  ];

  return (
    <ServicePageTemplate
      title="Web Development"
      subtitle="Build Powerful, Scalable Websites"
      description="From landing pages to complex web applications, we create websites that drive results. Using modern frameworks and best practices, we deliver fast, secure, and user-friendly solutions."
      features={features}
      benefits={benefits}
      pricing={servicePricing.webDevelopment}
      icon={Code}
      bgColor="#ffd1e7"
      process={process}
    />
  );
};

export default WebDevelopment;